module.exports = __webpack_public_path__ + "img/call.a8fedeea.svg";